export const all_routes = {
  invoices: "/invoices",
  addInvoice: "/invoice/add-invoice",
  editInvoice: "/invoice/edit-invoice",
  viewInvoice: "/invoice/view-invoice",
  profile: "/profile",
  users: "/users",
  addUser: "/user/add-user",
  editUser: "/user/edit-user",
  logout: "/logout",
  signin: "/signin",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
};
